import { FC } from 'react';
import { ImageBaseProps, ImageBaseSize } from '../../../image-base';
import { hasInitials } from '../../lib/has-initials/';
import { Entry } from './entry';

type Props = {
  size: ImageBaseSize;
  initials?: string;
  fallback?: ImageBaseProps['fallback'];
};

export const Guard: FC<Props> = ({ size, initials, fallback }) => {
  if (hasInitials(initials)) {
    return <Entry size={size} value={initials} />;
  }

  return fallback;
};
